/*
 * <video-testimonial> custom element.
 * Replaces thumbnail with the actual player on play-button click.
 * Supports two modes:
 *   data-video-type="file"     — Shopify-hosted MP4 (data-video-src is the file URL)
 *   data-video-type="external" — YouTube / Vimeo URL (data-video-src is the page URL)
 */
(function () {
  if (window.customElements && customElements.get('video-testimonial')) return;

  function youtubeId(url) {
    var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
  }

  function vimeoId(url) {
    var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : null;
  }

  function buildEmbedUrl(url) {
    var yt = youtubeId(url);
    if (yt) return 'https://www.youtube.com/embed/' + yt + '?autoplay=1&rel=0';
    var vm = vimeoId(url);
    if (vm) return 'https://player.vimeo.com/video/' + vm + '?autoplay=1';
    return null;
  }

  class VideoTestimonial extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('[data-video-play]');
      if (!btn) return;
      btn.addEventListener('click', this.play.bind(this));
    }

    play() {
      var src = this.getAttribute('data-video-src');
      var type = this.getAttribute('data-video-type');
      if (!src) return;

      var player;
      if (type === 'file') {
        player = document.createElement('video');
        player.src = src;
        player.controls = true;
        player.autoplay = true;
        player.playsInline = true;
        player.setAttribute('playsinline', '');
        player.className = 'video-testimonial__player';
      } else if (type === 'external') {
        var embedUrl = buildEmbedUrl(src);
        if (!embedUrl) {
          // Unknown provider — open in new tab as fallback
          window.open(src, '_blank', 'noopener');
          return;
        }
        player = document.createElement('iframe');
        player.src = embedUrl;
        player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        player.allowFullscreen = true;
        player.frameBorder = '0';
        player.className = 'video-testimonial__player';
      } else {
        return;
      }

      // Swap: keep overlays out of the way by hiding them; mount player as background-replacement
      this.classList.add('is-playing');
      this.style.backgroundImage = 'none';
      this.appendChild(player);
    }
  }

  customElements.define('video-testimonial', VideoTestimonial);
})();
